import { render, staticRenderFns } from "./AbsenceTableMaster.vue?vue&type=template&id=2f3f47c3&"
import script from "./AbsenceTableMaster.vue?vue&type=script&lang=js&"
export * from "./AbsenceTableMaster.vue?vue&type=script&lang=js&"
import style0 from "./AbsenceTableMaster.vue?vue&type=style&index=0&id=2f3f47c3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports